import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { Observable, Subject } from 'rxjs';
import {
  BaseAuthenticatedService,
  httpQueryParams,
  PaginatedResponse,
  RecursiveInterface,
} from './base-authenticated.service';
import { PaymentInterface } from '@app/interface/payment';

@Injectable({
  providedIn: 'root',
})
export class PaymentApiService extends BaseAuthenticatedService {
  constructor(
    public override auth: AngularFireAuth,
    public override httpClient: HttpClient // private cookieService: CookieService
  ) {
    super(auth, httpClient);
  }

  // using getRecursivePage
  public getAllPayments<T = PaymentInterface>(
    organization_id: number | null,
    params: httpQueryParams = {}
  ): Subject<RecursiveInterface<T>> {
    const path = `api/payment/`;
    return this.getRecursivePage<T>(path, params);
  }

  public getSpecificPayment<T = PaymentInterface>(
    organization_id: number | null,
    id: number,
    params: httpQueryParams = {}
  ): Observable<RecursiveInterface<T>> {
    const path = `api/payment/${id}/`;
    return this.getRecursivePage<T>(path, params);
  }

  public createPayment(
    organization_id: number,
    service: Partial<PaymentInterface>
  ): Observable<PaymentInterface> {
    const path = `api/payment/`;
    return this.post<PaymentInterface>(path, {}, service);
  }

  public updatePaymentDetails(
    organization_id: number | null,
    id: number,
    data: Partial<PaymentInterface>
  ): Observable<PaymentInterface> {
    return this.partialUpdate<PaymentInterface>(
      `api/payment/${id}/`,
      {}, //{ withCredentials: true },
      data
    );
  }
}
